import { apiDelete, apiGet, apiPost, apiPut } from '../../Api_Functions'

// Historia 226 (MIC-4441): Sun's label printing endpoints, frozen contract of `03-dominio.md` §"Contrato cross-repo
// congelado". Errors arrive as `{ status, data: { outcome, reason, … } }` from Api_Functions; callers branch on
// `data.outcome`, never on `reason`.

export const PRINTER_REQUEST_FIELDS = [
  'name', 'host', 'port', 'model', 'dpi', 'labelWidthMm', 'labelHeightMm', 'printWidthMm', 'horizontalOffsetMm',
  'printMethod', 'active'
]

export const listPrinters = () => apiGet('labelPrinters')

export const createPrinter = (request) => apiPost('labelPrinters', request)

export const updatePrinter = (id, request) => apiPut(`labelPrinters/${id}`, request)

export const deletePrinter = (id) => apiDelete(`labelPrinters/${id}`)

export const checkPrinter = (id) => apiPost(`labelPrinters/${id}/check`, {})

export const testPrintPrinter = (printerId, body = {}) => apiPost('labelPrinters/' + printerId + '/testPrint', body)

export const outcomeOf = (error) => error?.data?.outcome || ''

// [R2] Print, relaunch and history. Printer failures come as 409 (never 503, which would send the whole app to
// /connection_error); the truncation question as 422 TEXT_TRUNCATION_NOT_CONFIRMED.
export const printLabel = (request) => apiPost('qrLabels/print', request)

// Relaunch never carries fieldLabels: Sun reuses the ones stored in the record (RN38).
export const relaunchPrint = (printId, acceptTextTruncation) =>
  apiPost(`labelPrints/${printId}/relaunch`, { acceptTextTruncation })

// E15: filters are optional and combinable; only the chosen ones travel (without any, the request is the plain page).
export const HISTORY_FILTER_NAMES = ['from', 'to', 'username', 'printerId', 'outcome']

export const listPrintHistory = (page, size, filters = {}) => apiGet('labelPrints', {
  page,
  size,
  ...HISTORY_FILTER_NAMES.reduce((chosen, name) => (filters[name] ? { ...chosen, [name]: filters[name] } : chosen), {})
})

// [R3] Preview drawn by Sun (PNG in base64 inside the JSON).
export const previewLabel = (request) => apiPost('qrLabels/preview', request)

export const PRINTER_FAILURES = ['PRINTER_UNREACHABLE', 'PRINTER_STATUS_UNKNOWN', 'PRINTER_NOT_READY']

// E8: the authenticated user's default printer (`{ printerId }`, null when none). E9: print the labels of several parts
// in one request; it stops at the first printer failure and answers what it did.
// With `username` (E13/E21, ADMIN or SUPERADMIN) it reads the default printer of that user.
export const getDefaultPrinter = (username = '') => (username ? apiGet('labelPrinters/default', { username }) : apiGet('labelPrinters/default'))

export const setDefaultPrinter = (printerId, username = null) =>
  apiPut('labelPrinters/default', { printerId, ...(username ? { username } : {}) })

export const printBatch = (request) => apiPost('qrLabels/printBatch', request)

// E13: the users the administrator can assign a printer to. Sun binds `RequestPagination` through its all-args
// constructor: without `allSelected` the call is a 400, and a missing list field throws a 500 (NPE), so every field
// travels even when empty. Verified against the local Sun: 200 with `content[].username` (active users only).
export const USERS_PAGINATION = {
  page: 0,
  size: 100,
  allSelected: false,
  columns: 'username',
  sortKey: 'username',
  sortMode: 1,
  genericSearch: '',
  parameterFilters: '',
  parameterFiltersValues: '',
  parameterFiltersNames: '',
  genericSearchExcludedColumns: '',
  excludedColumns: '',
  columnFilters: '',
  columnFilterValues: '',
  columnFilterOperators: '',
  rows: '',
  primaryKeys: '',
  extraFilterName: '',
  extraFilterValue: '',
  // An empty JSON object: Sun parses this field as JSON and logs an ERROR for an empty string (E24).
  mixedColumnFilters: '{}'
}

// E18: search among the users (active only) by text, 50 at a time; without text, the first 50.
export const searchUsers = (text = '') => apiGet('user', { ...USERS_PAGINATION, size: 50, genericSearch: text })

// E23: who a printer is the default of (ADMIN or SUPERADMIN). `{ usernames: [...] }`.
export const listAssignedUsers = (printerId) => apiGet(`labelPrinters/${printerId}/assignedUsers`)
